// Standard-competition ranking with tie detection.
//
// Given rows already sorted by total_score DESC (as returned by
// /api/stats/leaderboard), stamp each row with:
//   • _rank  — Olympic-style shared rank ("1,2,2,4" not "1,2,3,4")
//   • _tied  — true if this row shares its total with at least one other row
//
// The tied flag drives a small "Tied" pill in the UI so users understand
// why two rows share a rank number.
export function computeRanks(rows) {
  if (!Array.isArray(rows) || rows.length === 0) return [];
  const out = rows.map((r) => ({ ...r }));
  let currentRank = 1;
  for (let i = 0; i < out.length; i += 1) {
    if (i === 0) {
      out[i]._rank = 1;
    } else if (out[i].total_score === out[i - 1].total_score) {
      out[i]._rank = out[i - 1]._rank; // share rank
    } else {
      out[i]._rank = currentRank;
    }
    currentRank = i + 2; // next unique rank if the NEXT row breaks a tie
  }
  // Second pass to stamp _tied. A row is tied if any other row has the
  // same total (regardless of rank position).
  const counts = out.reduce((acc, r) => {
    acc[r.total_score] = (acc[r.total_score] || 0) + 1;
    return acc;
  }, {});
  out.forEach((r) => { r._tied = counts[r.total_score] > 1; });
  return out;
}
